(function($) {
    $.Tracker = function () {
        // 1. set component name
        this._component_name = "tracker"; 

        // 2. set events
        this._events = {
            ready: "ready",
            finished_tracking: "finished_tracking",
            out_of_bounds: "out_of_bounds",
            bad_precision: "bad_precision",
            reset_tracking: "reset_tracking"
        };

        // 3. initialize flags and other data
        this._watch_id = -1; 
        this._location_overlays = [];

        this._location_loaded = false;
        this._tracker_init_finished = false;
        this._init_complete_emitted = false;
        this._enable_scroll = true;  

        // 4. => see _init

        $.Component.call(this, $.Tracker);
    };

    $.Component.create($.Tracker, {
        _init: function(options) { 
            this._options = options || {};
            // this._location_provider_opts = this._options.location_provider || {};
            this.viewers = this._options.viewers || this.parent.viewers || window.viewers || [];
            this.btnStartTracking = this._options.btn_start_tracking || 'button.btn-start-tracking';
            if (typeof(this.btnStartTracking) === 'string') {
                this.btnStartTracking = document.querySelector(this.btnStartTracking);
            }

            this._show_osm_map = this._options.show_osm_map || false;
            this._osm_map_zoom = this._options.osm_map_zoom || 15;
            this._osm_tilesize = this._options.osm_tile_size || 256;
            if(this.viewers.length > 0) {
                var viewer = this.viewers[0];
                viewer.addHandler('update-viewport', this._on_update_viewport_draw_osm.bind(this));
            }
            this._osm_cache = {};

            this._max_size = this._options.max_size || 100.0; 
            this._location_icon_width = this._options.location_icon_width || 0.01;
        
            this._reset_msgs(); 

            this.init();
            
            // 4. initialize subcomponents (if any)
            // this has to be done after this._options has been set
            $.Component.call(this, $.Tracker);  
        },

        // https://wiki.openstreetmap.org/wiki/Slippy_map_tilenames#ECMAScript_.28JavaScript.2FActionScript.2C_etc..29
        _lon2tile: function(lon,zoom) { return (lon+180)/360*Math.pow(2,zoom); },
        _lat2tile: function(lat,zoom)  { return (1-Math.log(Math.tan(lat*Math.PI/180) + 1/Math.cos(lat*Math.PI/180))/Math.PI)/2 *Math.pow(2,zoom); },
        _tile2lon: function(x,z) { return (x/Math.pow(2,z)*360-180); },
        _tile2lat: function(y,z) { var n=Math.PI-2*Math.PI*y/Math.pow(2,z); return (180/Math.PI*Math.atan(0.5*(Math.exp(n)-Math.exp(-n)))); },

        _preload_osm: function(onload, onerror) {
            
            var width = window.innerWidth;
            var height = window.innerHeight; 

            this.parent._show_ring();

            var x,y;
            var processed_tiles = {};
            var processed_tiles_n = 0;
            for (x = 0; x < width; x++) {
                for (y = 0; y < height; y++) {
                    var vp_coord = this.viewers[0].viewport.windowToViewportCoordinates(new OpenSeadragon.Point(x,y));
                    var lonlat = this.location_provider.vp2lonlat(vp_coord.x, vp_coord.y);
                    if (lonlat) {
                        var osm_coord = this._get_osm_coordinates(lonlat[1], lonlat[0], this._osm_map_zoom);
                        var tile_x = osm_coord.tile_coordinates.x;
                        var tile_y = osm_coord.tile_coordinates.y;
                        var tile_key = String(tile_x) + "_" + String(tile_y);
                        if (!(tile_key in processed_tiles)) { 
                            processed_tiles[tile_key] = { tile_x: tile_x, tile_y: tile_y, status: 0};
                            processed_tiles_n++;
                        }
                    }
                    else {
                        console.log("coordinates not available");
                    }  
                }
            }

            var self = this;
            var processed_tiles_correct = 0;
            for (var tile_key in processed_tiles) {
                var tile = processed_tiles[tile_key];
                this._get_osm_tile(tile.tile_x, tile.tile_y, this._osm_map_zoom, function(obj) { 
                    tile.status = 1;
                    processed_tiles_correct++;
                    if (processed_tiles_correct == processed_tiles_n) {
                        self.parent._hide_ring();
                        if (onload) {
                            onload.call(self, processed_tiles);
                        }
                    }
                },
                function(obj) {
                    tile.status = -1;
                    if (onerror) {
                        onerror.call(self, processed_tiles);
                    }
                    console.log("Failed to load OSM tile: (" + tile.tile_x + "," + tile.tile_y + ")");
                    self.parent._hide_ring();
                });
            }
        },

        
        _draw_osm: function(deformed) {
            if (typeof(deformed) !== 'boolean') {
                deformed = true;
            }

            this._preload_osm(this._draw_preloaded_osm.bind(this, deformed), function(processed_tiles){
                alert("failed to preload required OSM tiles");
            });
        },

        _draw_preloaded_osm_deformed: function() {
            var width = window.innerWidth;
            var height = window.innerHeight;

            var canvas_element = this.parent.viewers[0].canvas.querySelector("canvas");
            var canvas_ctx = canvas_element.getContext("2d");
            var canvas_imgdata = canvas_ctx.getImageData(0, 0, width, height);
            var canvas_data = canvas_imgdata.data;
            
            // var buffer = document.createElement("canvas");
            // buffer.width = width;
            // buffer.height = height;
            // var buffer_data = buffer.getContext("2d").getImageData(0, 0, width, height);
            for (var x = 0; x < width; x++) {
                for (var y = 0; y < height; y++) {
                    var vp_coord = this.viewers[0].viewport.windowToViewportCoordinates(new OpenSeadragon.Point(x,y));
                    var lonlat = this.location_provider.vp2lonlat(vp_coord.x, vp_coord.y);
                    if (lonlat) {
                        var osm_coord = this._get_osm_coordinates(lonlat[1], lonlat[0], this._osm_map_zoom);
                        var tile_x = osm_coord.tile_coordinates.x;
                        var tile_y = osm_coord.tile_coordinates.y;

                        var tile_obj = this._get_osm_tile(tile_x, tile_y, this._osm_map_zoom, function(obj){
                            
                        });
                        if (tile_obj) {
                            // var tile_ctx = tile_obj.canvas.getContext("2d");
                            // var pixel_data = tile_ctx.getImageData(osm_coord.tile_pixels.x, osm_coord.tile_pixels.y, 1, 1); 
                            var pixel_data = tile_obj.tile_data;
                            // buffer.getContext("2d").putImageData(pixel_data, x, y);
                            var red_index = y * (width*4) + x*4;
                            var red_index_tile = osm_coord.tile_pixels.y * (this._osm_tilesize * 4) + osm_coord.tile_pixels.x*4;
                            var tile_r = pixel_data[red_index_tile];
                            var tile_g = pixel_data[red_index_tile+1];
                            var tile_b = pixel_data[red_index_tile+2];
                            canvas_data[red_index] = tile_r;
                            canvas_data[red_index+1] = tile_g;
                            canvas_data[red_index+2] = tile_b;
                            canvas_data[red_index+3] = 255;
                        } 
                        else {
                            // console.error(tile_obj);
                        }
                    }
                    else {
                        console.error(lonlat);
                    }
                }
                console.log("column " + x + "/" + (width-1))
            }

            // buffer.getContext("2d").putImageData(buffer_data, 0, 0);
            // canvas_ctx.drawImage(buffer, 0, 0);
            canvas_ctx.putImageData(canvas_imgdata, 0, 0); 
        },

        _draw_preloaded_osm: function(deformed) {
            if (deformed) {
                this._draw_preloaded_osm_deformed();
                return;
            }


            var width = window.innerWidth;
            var height = window.innerHeight;

            var canvas_element = this.parent.viewers[0].canvas.querySelector("canvas");
            var canvas_ctx = canvas_element.getContext("2d");
            var canvas_imgdata = canvas_ctx.getImageData(0, 0, width, height);
            var canvas_data = canvas_imgdata.data;
            
            // get topleft and bottomright vp coordinates and their respective GPS coordinates
            var vp_coord_topleft = this.viewers[0].viewport.windowToViewportCoordinates(new OpenSeadragon.Point(0,0));
            var vp_coord_rightbottom = this.viewers[0].viewport.windowToViewportCoordinates(new OpenSeadragon.Point(width-1,height-1));
            var lonlat_topleft = this.location_provider.vp2lonlat(vp_coord_topleft.x, vp_coord_topleft.y);
            var lonlat_rightbottom = this.location_provider.vp2lonlat(vp_coord_rightbottom.x, vp_coord_rightbottom.y);
            var lonlat_diff = [lonlat_rightbottom[0] - lonlat_topleft[0], lonlat_rightbottom[1] - lonlat_topleft[1]];

            // paint interpolating linearly over those bounds restricted to the image pixels
            for (var x = 0; x < width; x++) {
                for (var y = 0; y < height; y++) {
                    var x_center = (x + 0.5) / width;
                    var y_center = (y + 0.5) / height;
                    var lonlat = [lonlat_topleft[0] + x_center*lonlat_diff[0], lonlat_topleft[1] + y_center*lonlat_diff[1]];  
                    var osm_coord = this._get_osm_coordinates(lonlat[1], lonlat[0], this._osm_map_zoom);
                    var tile_x = osm_coord.tile_coordinates.x;
                    var tile_y = osm_coord.tile_coordinates.y;

                    var tile_obj = this._get_osm_tile(tile_x, tile_y, this._osm_map_zoom, function(obj){
                        
                    });
                    if (tile_obj) {
                        // var tile_ctx = tile_obj.canvas.getContext("2d");
                        // var pixel_data = tile_ctx.getImageData(osm_coord.tile_pixels.x, osm_coord.tile_pixels.y, 1, 1); 
                        var pixel_data = tile_obj.tile_data;
                        // buffer.getContext("2d").putImageData(pixel_data, x, y);
                        var red_index = y * (width*4) + x*4;
                        var red_index_tile = osm_coord.tile_pixels.y * (this._osm_tilesize * 4) + osm_coord.tile_pixels.x*4;
                        var tile_r = pixel_data[red_index_tile];
                        var tile_g = pixel_data[red_index_tile+1];
                        var tile_b = pixel_data[red_index_tile+2];
                        canvas_data[red_index] = tile_r;
                        canvas_data[red_index+1] = tile_g;
                        canvas_data[red_index+2] = tile_b;
                        canvas_data[red_index+3] = 255;
                    } 
                    else {
                        // console.error(tile_obj);
                    } 
                }
                console.log("column " + x + "/" + (width-1))
            }

            // buffer.getContext("2d").putImageData(buffer_data, 0, 0);
            // canvas_ctx.drawImage(buffer, 0, 0);
            canvas_ctx.putImageData(canvas_imgdata, 0, 0); 
        },

        _on_update_viewport_draw_osm: function(evt) {
            if (this._show_osm_map) {
                // this._draw_osm();
            }
        },

        _get_osm_coordinates: function(lat, lon, zoom) { 
            var tile_point = new OpenSeadragon.Point(this._lon2tile(lon, zoom), this._lat2tile(lat, zoom));
            var tile_coordinates = { x: Math.floor(tile_point.x), y: Math.floor(tile_point.y) };

            var tile_pixels = {
                x: Math.floor( (tile_point.x - tile_coordinates.x)*this._osm_tilesize), 
                y: Math.floor( (tile_point.y - tile_coordinates.y)*this._osm_tilesize)};

            return { tile_point: tile_point, tile_coordinates: tile_coordinates, tile_pixels: tile_pixels };
        },

        _get_osm_tile: function(tile_x, tile_y, zoom, onload_callback, onerror_callback) { 

            var cache_key = String(zoom) + "/" + String(tile_x) + "/" + String(tile_y);

            if (cache_key in this._osm_cache && this._osm_cache[cache_key].status === "loaded") {
                if (! ("tile_data" in this._osm_cache[cache_key])) {
                    var canvas = document.createElement("canvas");
                    canvas.width = this._osm_tilesize;
                    canvas.height = this._osm_tilesize;
                    var ctx = canvas.getContext("2d"); 
                    ctx.drawImage(this._osm_cache[cache_key].image, 0, 0, this._osm_tilesize, this._osm_tilesize);

                    this._osm_cache[cache_key].canvas = canvas;
                    this._osm_cache[cache_key].tile_data = ctx.getImageData(0,0,this._osm_tilesize, this._osm_tilesize).data;
                }

                // this._emit("osm_tile_loaded_" + cache_key, this._osm_cache[cache_key]);
                if (onload_callback) {
                    onload_callback(this._osm_cache[cache_key]);
                }

                return this._osm_cache[cache_key];
            }
            else {
                // console.log("waiting_for_cache");
                if (onload_callback) {
                    this._once("osm_tile_loaded_" + cache_key, onload_callback);
                }
                if (onerror_callback) {
                    this._once("osm_tile_error_" + cache_key, onerror_callback);
                }
                var self = this;
                // var img = new Image(this._osm_tilesize, this._osm_tilesize);
                var img = new Image(this._osm_tilesize, this._osm_tilesize);
                img.crossOrigin = "Anonymous";
                var cache_obj = { image: img, status: "loading" };
                this._osm_cache[cache_key] = cache_obj;
                img.onload = function(evt) {  
                    var cache_obj = { image: img, zoom: zoom, x: tile_x, y: tile_y, status: "loaded"};
                    self._osm_cache[cache_key] = cache_obj;
                    self._emit("osm_tile_loaded_" + cache_key, cache_obj);
                };
                img.onerror = function(evt) {
                    var cache_obj = { image: img, zoom: zoom, x: tile_x, y: tile_y, status: "error"};
                    self._osm_cache[cache_key] = cache_obj;
                    self._emit("osm_tile_error_" + cache_key, cache_obj);
                };
                
                img.src = "https://a.tile.openstreetmap.org/" + String(zoom) + "/" + String(tile_x) + "/" + String(tile_y) + ".png"

                img.style.position = "fixed";
                img.style.top = "0";
                img.style.left = "0";
                img.style.display = "none";
                document.body.appendChild(img);
                return null;
            }
        },

        _check_init_flags: function() {
            if (this._location_loaded && this._tracker_init_finished) {
                return true;
            }

            return false;
        },

        init: function() {
            var self = this;
            var viewer;
            // httpsじゃないとGPSが動かないから
            // httpだとhttpsに移動
            // source: https://stackoverflow.com/questions/4723213/detect-http-or-https-then-force-https-in-javascript
            if (location.protocol !== 'file:' && location.protocol !== 'https:') {
                //location.replace(`https:${location.href.substring(location.protocol.length)}`); // IEで動かない
                location.replace('https:' + location.href.substring(location.protocol.length));
            }
 
            if (navigator.geolocation) { 
                if (this.btnStartTracking != null) {
                    this.btnStartTracking.addEventListener(ABDOUtil.getClickHandler(this.btnStartTracking), function(evt){
                        self.btnStartTrackingClick.call(self, evt, this);
                    });
                } 

                var i, viewers_n = this.viewers.length;
                for (i = 0; i < viewers_n; i++) {
                    viewer = this.viewers[i];
                    viewer.addHandler('canvas-drag', this.enableScroll.bind(this, false));
                }
        
                // var chkEnableScroll = document.getElementById(this.chkEnableScrollId);
                // if (chkEnableScroll != null) {
                //     chkEnableScroll.onchange = function(evt) { 
                //         // original this, event, button
                //         self.chkEnableScrollChange.call(self, evt, this); 
                //     };
                // }
            }
            
            for (var index = 0; index < this.viewers.length; index++) {
                viewer = this.viewers[index];
                viewer.addHandler('update-viewport', this.updateViewport.bind(this, viewer));
                // viewer.addHandler('update-viewport', function(evt) { 
                //     self.updateViewport.call(self, viewer, evt); 
                // });
            }
            

            if (this._check_init_flags() && !this._init_complete_emitted) {
                this._emit(this._events.ready);
            } 
        },
        
        enableScroll: function(value) {
            this._enable_scroll = typeof(value) === 'undefined' ? true : value; 
        },

        updateViewport: function(viewer, evt) {
            // 位置情報の精度半径を更新
            var overlays = this._location_overlays;
            for (var index = 0; index < overlays.length; index++) {
                var overlay = overlays[index];
                var location_accuracy_element = overlay.element.querySelector('.location-accuracy');
                if (location_accuracy_element) {
                    var resolution = overlay.element.clientWidth / overlay.element.dataset.size; // px / m
                    var accuracy_size = resolution*location_accuracy_element.dataset.accuracy;
                    var offset = accuracy_size*-0.5;

                    location_accuracy_element.style.width = accuracy_size + 'px';
                    location_accuracy_element.style.height = accuracy_size + 'px';
                    location_accuracy_element.style.left = offset + 'px';
                    location_accuracy_element.style.top = offset + 'px';

                }
            }
        },

        _show_toast: function(id) {
            var toastElement = document.getElementById(id);
            if (toastElement == null || toastElement.classList.contains('show')) {
                return;
            }
            jQuery(toastElement).toast('show');
        },
        _toast_hide_if_shown: function(id) {
            var toastElement = document.getElementById(id);
            if (toastElement == null || toastElement.classList.contains('show')) {
                jQuery(toastElement).toast('hide');
            }
        },
        // ユーザーのプラットフォームを検出するための関数
        guess_ios: function() {
            var ios_platforms = [
                'iPad Simulator','iPhone Simulator','iPod Simulator','iPad','iPhone','iPod'];
            return ios_platforms.includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
        },
        guess_android: function() {
            var ua = navigator.userAgent.toLowerCase();
            return ua.indexOf("android") > -1;
        },
        guess_other: function() {
            return !this.guess_android() && !this.guess_ios();
        },
        // 地図の自動回転の関数
        slider_rotation: 0,
        start_rotating: function() {},
        stop_rotating: function() {},
        addLocationOverlays: function(location) {
            for (var index = 0; index < this.viewers.length; index++) {
                var viewer = this.viewers[index];

                var icon_size_m = this.location_provider.estimate_size(location, this._location_icon_width);
                var locationOverlay = document.createElement('div');
                locationOverlay.classList.add('location-overlay'); 
                locationOverlay.id = 'currentLocation-' + index;
                locationOverlay.dataset.x = location.x;
                locationOverlay.dataset.y = location.y;
                locationOverlay.dataset.size = icon_size_m;
                
                var accuracyDiv = document.createElement('div');
                accuracyDiv.classList.add('location-accuracy'); 
                locationOverlay.appendChild(accuracyDiv);

                var imgdiv = document.createElement('div');
                imgdiv.classList.add('icon-location');  
                locationOverlay.appendChild(imgdiv); 

                document.body.appendChild(locationOverlay);

                viewer.addOverlay({
                    element: locationOverlay,
                    location: location,
                    width: this._location_icon_width,
                    height: this._location_icon_width,
                    onDraw: this._on_overlay_draw.bind(this)
                });

                var added_overlay = viewer.getOverlayById(locationOverlay.id);
                added_overlay.viewer_index = index;
                this._location_overlays.push(added_overlay);
            } 
        },

        _on_overlay_draw: function(position, size, element) {
            ABDOUtil._resize_overlay(size, this.parent.overlay._max_size);
            element.style.width = size.x + 'px';
            element.style.height = size.y + 'px';

            // top and left set to 0 to use CSS translate later
            if (!element.style.left) {
                element.style.left = '0px';
            }

            if (!element.style.top) {
                element.style.top = '0px';
            }

            element.style.transform = 'translateX(' + position.x + 'px) translateY(' + position.y + 'px)';
        },

        _removeLocationOverlays: function () {  
            for (var index = 0; index < this._location_overlays.length; index++) {
                var overlay = this._location_overlays[index];
                this.viewers[overlay.viewer_index].removeOverlay(overlay.element.id);
            }

            this._location_overlays = [];
        },
        btnStartTrackingClick: function(evt, btn) {

            var overlays = this._location_overlays; 
            // 追跡はすでに始まっているから現在地に移動してから辞めます
            if (overlays.length > 0) {
                var currentLocationElement = overlays[0].element;
                var location = ABDOUtil.getPointFromDataset(currentLocationElement);
                var viewer = ABDOUtil.getViewer();
                viewer.viewport.panTo(location);
                this.enableScroll();

                this._emit(this._events.finished_tracking, {
                    detail: {
                        location: location,
                        position: null
                    }
                });
                
                return;
            }

            
            if (this._watch_id < 0) {
                //start_rotating();
                var self = this;
 
                var geolocation_options = {
                    enableHighAccuracy: true,
                    timeout: 1000,
                    maximumAge: 0,
                };
                this.enableScroll();
                this._reset_msgs();
                
                this._watch_id = navigator.geolocation.watchPosition(
                    this.watchPosition.bind(this), 
                    this.watchPositionError.bind(this),
                    geolocation_options);
            }
            else {
                navigator.geolocation.clearWatch(this._watch_id);
                this._watch_id = -1;
            }
        }, 

        _reset_msgs: function() {
            this._messages = {
                _out_of_bounds : {
                    _shown: false
                },
                _bad_precision : {
                    _shown: false
                },
            };
        },

        _check_bounds: function(gps_position, location) {
            var viewer = ABDOUtil.getViewer();
            var bounds = viewer.world.getHomeBounds();
            var viewport_ok = bounds.containsPoint(location);
            var gps_ok = this.location_provider.check_bounds_gps(gps_position.coords.longitude, gps_position.coords.latitude);
            if (!viewport_ok || !gps_ok)  { 
                this._show_out_of_bounds();

                this._emit(this._events.out_of_bounds);

                return false;
            }
            
            this._hide_out_of_bounds(); 

            return true;
        },

        _show_out_of_bounds: function() {
            if (!this._messages._out_of_bounds._shown) {
                this._show_toast('toastOutofBounds'); 
                this._messages._out_of_bounds._shown = true;
            }

            if (this._location_overlays.length > 0) {
                this._removeLocationOverlays();
            }

            this._emit(this._events.out_of_bounds);
        },

        _hide_out_of_bounds: function() {
            this._messages._out_of_bounds._shown = false;
            this._toast_hide_if_shown('toastOutofBounds');
        },
        

        _check_precision: function(gps_position) {
            // 現在地を表示ボタンのデータ要素でdata-max-accuracyの閾値でこの表示が出ます
            var max_accuracy = 500;
            if (this.btnStartTracking) {
                max_accuracy = parseFloat(this.btnStartTracking.dataset.maxAccuracy);
            }

            if (gps_position.coords.accuracy > max_accuracy) { 
                if(!this._messages._bad_precision._shown) {
                    this._show_toast('toastBadPrecision');
                    this._messages._bad_precision._shown = false;
                }
                
                if (this._location_overlays.length > 0) {
                    this._removeLocationOverlays();
                }

                this._emit(this._events.bad_precision);
                
                return false;
            }
            else {
                this._toast_hide_if_shown('toastBadPrecision');
            }

            return true;
        },

        markPosition: function(gps_position, location) {
            var viewer = ABDOUtil.getViewer(); 

            // 精度が悪いときはユーザーに警報し、現在地のアイコンを削除する
            if (!this._check_precision(gps_position)) {
                return;
            }

            // 範囲外になると警報を表示
            if (!this._check_bounds(gps_position, location)) { 
                return;
            } 

            // オーバーレイがなければ追加する
            var added_new = false;
            if (this._location_overlays.length == 0) {
                this.addLocationOverlays(location); 
                added_new = true;
                if (this._enable_scroll) {
                    viewer.viewport.panTo(location).zoomTo($._get_default_zoom());
                }
            } 
            
            // オーバーレイ情報の更新
            for (var index = 0; index < this._location_overlays.length; index++) {
                var overlay = this._location_overlays[index];

                var location_accuracy_element = overlay.element.querySelector('.location-accuracy');
                if (location_accuracy_element) {
                    location_accuracy_element.dataset.x = location.x;
                    location_accuracy_element.dataset.y = location.y;
                    location_accuracy_element.dataset.accuracy = gps_position.coords.accuracy;
                }

                if (!added_new) {
                    overlay.element.dataset.x = location.x;
                    overlay.element.dataset.y = location.y;
                    this.viewers[index].updateOverlay(overlay.element, location);
                }
            }

            if (this._enable_scroll) {
                viewer.viewport.panTo(location);
            } 

            var accuracyElement = document.getElementById('accuracy');
            if (accuracyElement != null) {
                accuracyElement.innerText = gps_position.coords.accuracy.toFixed(2) + "m";
            }

            this._emit(this._events.finished_tracking, {
                detail: {
                    location: location,
                    position: gps_position
                }                
            });
        }, 
        watchPosition: function(position, watch) {  
            var dlgPermissionDenied = document.getElementById('dlgPermissionDenied');
            jQuery(dlgPermissionDenied).modal('hide'); 

            if (this.location_provider != null) { 
                var lonlat = this.location_provider.lonlat2vp(position.coords.longitude, position.coords.latitude);
                if (lonlat) {
                    var vp_point = new OpenSeadragon.Point(
                        lonlat[0], lonlat[1]
                    );
                    // var vp_point = new OpenSeadragon.Point(
                    //     this.location_provider.lon2x(position.coords.longitude), 
                    //     this.location_provider.lat2y(position.coords.latitude));
                    
                    if (this.location_provider.has_elevation()) {
                        var elevation =  this.location_provider.get_elevation(vp_point.x, vp_point.y);
                        //console.log(`${position.coords.longitude},${position.coords.latitude}, ${elevation}`); 
                    }
                    this.markPosition(position, vp_point);
                    
                    //todo send a message to the user
                }
                else {
                    console.log("GPS変換の精度の限界です");
                }
            }
            else {
                console.log('位置情報の変換が読み込まれていない');
            }
            
           
        },

        watchPositionError: function(error, obj) {
            if (error.code == GeolocationPositionError.PERMISSION_DENIED) {
                if (this.guess_ios()) {
                    jQuery('#collapse-iphone').collapse();
                }
                else if (this.guess_android()) {
                    jQuery('#collapse-android').collapse();
                }
                else {
                    jQuery('#collapse-pc').collapse();
                }
                
                jQuery('#dlgPermissionDenied').modal('show');
            }
            else {
                console.dir(error);
                // POSITION_UNAVAILABLEかTIMEOUT
            }
            
            // delete current watch
            if (this._watch_id >= 0) {
                navigator.geolocation.clearWatch(this._watch_id);
                this._watch_id = -1;
            }
            
        },
        resetTracking: function(callback) {
            if(this._watch_id >= 0) {
                navigator.geolocation.clearWatch(this._watch_id);
                this._watch_id = -1;
                this._removeLocationOverlays();
                
            }

            if (typeof(callback) !== 'undefined' && callback != null) {
                callback();
            }

            this._emit(this._events.reset_tracking);
        }
    }, $.OSD);
})(ABDOMap);